"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
require("./styles.scss");
function LocationSkipToMainContent({ mainContentId, }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "ontario-skip-to-main-content text-center" }, { children: (0, jsx_runtime_1.jsx)("a", Object.assign({ href: "#" + mainContentId, className: "show-on-focus" }, { children: t("layout.skipToMainContent") })) })));
}
exports.default = LocationSkipToMainContent;
